import logger from '../helpers/logger';
import passKeyHelper from '../helpers/passKey';
import { PayWithCashRequest } from '../typegen/pay-with-cash-request';
import { LegacyPostAcceptedPayment, LegacyPostRejectedPayment } from './legacyAdminApi';
import PendingCashPayment from './PendingCashPayment';

interface CashPaymentDataProps extends PendingCashPayment {
	amountToPay: number;
	ones: number;
	twos: number;
	fives: number;
	tens: number;
	twenties: number;
	fifties: number;
	hundreds: number;
	unknownCount?: number;
	unknownAmount?: number;
	isPrePay?: boolean;
	timestamp: string;
	paymentReference: string;
}

class CashPaymentData {
	constructor(public props: CashPaymentDataProps) {}

	toPayWithCashRequest(): PayWithCashRequest {
		const request: PayWithCashRequest = {
			paymentId: this.props.id,
			customerName: this.props.customerName,
			utilityAccountNumber: this.props.utilityAccountNumber,
			accountToken: this.props.accountToken ?? undefined,
			amountDue: this.props.amountToPay,
			amountToPay: this.props.amountToPay,
			isPrePay: this.props.isPrePay,
			ones: this.props.ones,
			twos: this.props.twos,
			fives: this.props.fives,
			tens: this.props.tens,
			twenties: this.props.twenties,
			fifties: this.props.fifties,
			hundreds: this.props.hundreds,
			unknownCount: this.props.unknownCount,
			unknownAmount: this.props.unknownAmount,
			paymentReference: this.props.paymentReference,
			paymentGatewayItemNumber: this.props.paymentGatewayId,
			paymentGuid: this.props.paymentGuid,
		};

		// HOTFIX if this property is set and the value is null, it will fail on the server
		// TODO: REVISIT LATER
		if (this.props.invoiceGuid) request.invoiceGuid = this.props.invoiceGuid;
		if (this.props.paymentTypeId) request.paymentTypeId = this.props.paymentTypeId;
		if (this.props.group) request.group = this.props.group;
		if (this.props.classification) request.classification = this.props.classification;

		return request;
	}

	async toLegacyPostAcceptedPaymentRequest(kioskPaymentId?: string | null): Promise<LegacyPostAcceptedPayment> {
		logger.debug.warn('update the legacy kiosk id, paymentGuid, paymentGatewayExternalID, cisProvider, paymentGateway');
		return {
			dynatouchGUID: this.props.legacyGuid,
			firstCashTransaction: true,
			customerID: this.props.companyId.toString(),
			kioskID: this.props.kioskId.toString(),
			paymentGatewayExternalID: this.props.paymentGatewayId,
			paymentDateTime: this.props.timestamp,
			paymentAmount: this.props.amountToPay,
			paymentType: 'Cash',
			paymentGUID: this.props.paymentGuid,
			passKey: await passKeyHelper.generatePassKey(),
			cashOnes: this.props.ones,
			cashTwos: this.props.twos,
			cashFives: this.props.fives,
			cashTens: this.props.tens,
			cashTwenties: this.props.twenties,
			cashFifties: this.props.fifties,
			cashHundreds: this.props.hundreds,
			cisProvider: this.props.cisProviderName,
			paymentGateway: this.props.paymentGatewayName,
			cisProviderExternalID: this.props.cisId,
			payorName: this.props.customerName,
			paymentReference: this.props.paymentReference,
			kioskPaymentId: kioskPaymentId ?? undefined,
		};
	}

	async toLegacyPostRejectedPaymentRequest(): Promise<LegacyPostRejectedPayment> {
		logger.debug.warn('update the legacy kiosk id, paymentGuid, paymentGatewayExternalID, cisProvider, paymentGateway');
		return {
			customerID: this.props.companyId.toString(),
			kioskID: this.props.kioskId.toString(),
			billpaySessionGUID: this.props.legacyGuid,
			rejectedECID: '',
			rejectedReason: 'Cash payment error',
			rejectedPaymentType: 'Cash',
			paymentAmount: this.props.amountToPay,
			payorName: this.props.customerName,
			paymentDateTime: this.props.timestamp,
			passKey: await passKeyHelper.generatePassKey(),
		};
	}
}

export default CashPaymentData;
